import React from 'react'
import Sparkle from '../../../icons/sparkle'
import styles from './AiSearch.module.css'

const AiGeneragedPill = () => {
  return (
    <div className={styles.pill}>
      <Sparkle width={'11'} height={'12'} />
      <span className={styles.ml1}>AI-GENERATED</span>
    </div>
  )
}

export default AiGeneragedPill
